<template>
  <div
    v-if="workspaceStore.workspace"
    id="user-view"
  >
    <!-- tabs -->
    <v-tabs
      v-model="tab"
      class="user-tabs"
      style="position: relative; z-index: 0;"
      show-arrows
    >
      <v-tab
        v-for="(t, index) in tabs"
        v-show="$canACL('view', t.resource, workspaceStore.workspace.organization_id)"
        :key="t.icon"
        :disabled="!$canACL(t.action, t.resource, workspaceStore.workspace.organization_id)"
        @click="onTabEvent(index)"
      >
        <v-icon
          size="20"
          class="me-3"
        >
          {{ t.icon }}
        </v-icon>
        <span>{{ $t(t.title) }}</span>
      </v-tab>
    </v-tabs>

    <!-- tabs item -->
    <v-tabs-items
      id="user-tabs-content"
      v-model="tab"
    >
      <v-tab-item>
        <workspace-details
          :workspace="workspaceStore.workspace"
          :tab="tab"
        ></workspace-details>
      </v-tab-item>
      <v-tab-item>
        <workspace-theme
          :workspace="workspaceStore.workspace"
        ></workspace-theme>
      </v-tab-item>
      <v-tab-item>
        <workspace-tokens
          :workspace="workspaceStore.workspace"
        ></workspace-tokens>
      </v-tab-item>
      <v-tab-item v-if="false">
        <workspace-settings
          :workspace="workspaceStore.workspace"
        ></workspace-settings>
      </v-tab-item>
      <v-tab-item>
        <workspace-migrations
          :workspace="workspaceStore.workspace"
        ></workspace-migrations>
      </v-tab-item>
      <v-tab-item>
        <workspace-logs
          :workspace="workspaceStore.workspace"
        ></workspace-logs>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { useUserStore } from '@/stores/user.store'
import { useWorkspacesStore } from '@/stores/workspaces.store'
import WorkspaceDetails from '@/views/workspaces/settings/WorkspaceDetails.vue'
import WorkspaceLogs from '@/views/workspaces/settings/WorkspaceLogs.vue'
import WorkspaceMigrations from '@/views/workspaces/settings/WorkspaceMigrations.vue'
import WorkspaceSettings from '@/views/workspaces/settings/WorkspaceSettings.vue'
import WorkspaceTheme from '@/views/workspaces/settings/WorkspaceTheme.vue'
import WorkspaceTokens from '@/views/workspaces/settings/WorkspaceTokens.vue'
import { appConfig } from '@/plugins/micleoConfig'
import {
  getCurrentInstance,
  onMounted, onUnmounted,
  ref,
} from 'vue'

export default {
  metaInfo: {
    title: 'Workspace',
    titleTemplate: `%s | ${appConfig.theme.app.name}`,
    meta: [
      { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'description', content: appConfig.theme.app.description },
    ],
  },
  components: {
    WorkspaceDetails,
    WorkspaceTokens,
    WorkspaceMigrations,
    WorkspaceLogs,
    WorkspaceSettings,
    WorkspaceTheme,
  },
  setup() {
    const tab = ref(0)
    const subscription = ref(null)
    const vm = getCurrentInstance().proxy

    const workspaceStore = useWorkspacesStore()
    const userStore = useUserStore()

    // tabs
    const tabs = [
      {
        title: 'General', icon: 'mdi-application', action: 'read', resource: 'workspaces',
      },
      {
        title: 'AppCustomizer', icon: 'mdi-palette', action: 'read', resource: 'workspaces',
      },
      {
        title: 'ProjectAPIKeys', icon: 'mdi-key', action: 'read', resource: 'workspaces',
      },

      /* {
        title: 'Supabase', icon: 'mdi-database-cog', action: 'read', resource: 'workspaces',
      }, */
      {
        title: 'Console', icon: 'mdi-console', action: 'read', resource: 'workspaces',
      },
      {
        title: 'Logs', icon: 'mdi-alert-box', action: 'read', resource: 'workspaces',
      },
    ]

    if (vm.$router.currentRoute.params?.tab) {
      tab.value = parseInt(vm.$router.currentRoute.params.tab, 10)
    }

    onMounted(async () => {
      subscription.value = await workspaceStore.listenWorkspace(vm.$router.currentRoute.params.id)
    })

    onUnmounted(() => {
      userStore.removeChannel(subscription.value)
    })

    const onTabEvent = t => {
      vm.$router.push({ name: 'edit-workspace', params: { tab: t, id: vm.$router.currentRoute.params.id } })
    }

    return {
      tab,
      tabs,
      onTabEvent,
      workspaceStore,
    }
  },
  data() {
    return {
      subscription: null,
    }
  },
}
</script>
<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
